// extracted by mini-css-extract-plugin
export default {"alfa":"SensorType_alfa__czKiJ","btadd":"SensorType_btadd__41pVr","creer":"SensorType_creer__AG1ch"};